import { Component, Input, OnInit } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { IApiInvestigation, IApiSageClass } from 'src/app/shared/modules/graphql/types/types';
import { LoaderService } from 'src/app/shared/modules/loader/loader.service';
import { NotificationsService } from 'src/app/shared/modules/notifications/notifications.service';
import { CompanyService, ContactService } from 'src/app/shared/services';

@Component({
  selector: 'app-sage-class-selection-modal',
  templateUrl: './sage-class-selection-modal.component.html',
  styleUrls: ['./sage-class-selection-modal.component.scss']
})
export class SageClassSelectionModalComponent extends DialogContentBase implements OnInit {
  @Input() investigation: IApiInvestigation;
  public sageClasses: IApiSageClass[] = [];
  public selectedSageId = '';

  constructor(
    public dialogRef: DialogRef,
    private companyService: CompanyService,
    private loader: LoaderService,
    private notification: NotificationsService
  ) {
    super(dialogRef);
  }
  ngOnInit(): void {
    this.loader.show$(this.companyService.getSageClassesByCompanyId(this.investigation?.BillToBranch?.Company?.id).pipe(this.notification.snackbarErrorPipe())).subscribe(response => {
      this.sageClasses = response;
    });
  }

  close(result = false) {
    this.dialogRef.close(result);
  }


  submit = () => {
    if (!this.selectedSageId) {
      this.notification.snackbarError('Please select a class or create a new one');
    }
    if (this.selectedSageId === 'NEW') {
      this.loader.show$(this.companyService.createSageClass(this.investigation?.BillToBranch?.Company?.id).pipe(this.notification.snackbarPipe('SAGE class created successfully'), this.notification.snackbarErrorPipe())).subscribe((response) => {
        this.dialogRef.close(response);
      });
    } else {
      const sageKey = this.sageClasses.find(s => s.id === this.selectedSageId)?.key || '';
      this.loader.show$(this.companyService.update({
        id: this.investigation?.BillToBranch?.Company?.id,
        sageKey: sageKey,
        name: this.investigation?.BillToBranch?.Company?.name,
      }).pipe(this.notification.snackbarPipe('SAGE class updated successfully'), this.notification.snackbarErrorPipe())).subscribe(response => {
        this.dialogRef.close(response);
      })
    }
  }
}
